import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import Carousel from '../Carousel/Carousel';
import { TestimonialContainer, TestimonialRow } from './Testimonial.styled';
import TestimonialCard from './TestimonialCard';
import { settings, testimonialData } from './TestimonialConfig';
/**
 * Testimonials component displays a carousel of testimonial cards.
 *
 * @component
 * @returns {JSX.Element} The rendered Testimonials component.
 */
const Testimonials = () => {
  const t = useTranslation();

  return (
    <TestimonialContainer data-testid='TestimonialPage-item'>
      <TestimonialRow>
        <div className='title'>{t('app.BLOGS_TITLE')}</div>
        <Carousel config={settings}>
          {testimonialData({ t }).map((data, index) => {
            return (
              <TestimonialCard
                img={data.userImage}
                text={data.text}
                key={index}
                name={data.userName}
                designation={data.Designation}
              />
            );
          })}
        </Carousel>
      </TestimonialRow>
    </TestimonialContainer>
  );
};

export default Testimonials;
